export function setUpAccordionClickHandlers() {
  const accordionItems = document.getElementsByClassName(
    'accordion__root accordion'
  );
  const accordionClickHandler = (event) => {
    if (event.target.classList.contains('accordion__item')) {
      event.target.classList.toggle('accordion__item--open');
    } else if (event.target.parentNode.classList.contains('accordion__item')) {
      event.target.parentNode.classList.toggle('accordion__item--open');
    }
  };

  for (const item of accordionItems) {
    item.addEventListener('click', accordionClickHandler);
  }
}

export function setUpClickHandlers($node) {
  $node
    .find('ul.accordion__root > li.accordion__item > h5')
    .on('click', function () {
      const self = $(this);
      const listItem = self.parent('li');
      listItem.toggleClass('accordion__item--open');
      self
        .find('button')
        .attr(
          'aria-expanded',
          `${listItem.hasClass('accordion__item--open') ? 'true' : 'false'}`
        );
      return false;
    });
}
